// Configuración de permisos de menú por perfil
// Este archivo permite configurar fácilmente qué opciones de menú puede ver cada perfil

import {  HandCoins, Home, Package, Target, User, Users, Settings, LineChart, UserMinus, Compass, Headset, MessageSquareWarning, Hand, FilterIcon, Receipt } from "lucide-react";
import { FaUserTie } from 'react-icons/fa';

export const allMenus = [
  { id: 'dashboard', label: 'Inicio', path: '/admin', icon: <Home size={20} />, permiso: 'menu_dashboard' },
  { id: 'ventas', label: 'Ventas', path: '/admin/ventas', icon: <HandCoins size={20} />, permiso: 'menu_sales' },
  { id: 'bienvenida', label: 'Bienvenida', path: '/admin/bienvenida', icon: <Hand size={20} />, permiso: 'menu_welcome' },
  { id: 'cobranzas', label: 'Cobranzas', path: '/admin/recibos', icon: <Receipt size={20} />, permiso: 'menu_cobranza' },
  { id: 'reportadas', label: 'Reportados', path: '/admin/reportadas', icon: <MessageSquareWarning size={20} />, permiso: 'menu_reported' },
  { id: 'leads', label: 'Leads', path: '/admin/leads', icon: <FilterIcon size={20} />, permiso: 'leads' },
  { id: 'clientes', label: 'Clientes', path: '/admin/clientes', icon: <User size={20} />, permiso: 'menu_customers' },
  { id: 'bajas', label: 'Solicitud de Bajas', path: '/admin/solicitudbaja', icon: <UserMinus size={20} />, permiso: 'menu_low_request' },
  { id: 'productos', label: 'Productos', path: '/admin/productos', icon: <Package size={20} />, permiso: 'menu_products' },
  { id: 'reclutamiento', label: 'Reclutamiento', path: '/admin/reclutamiento', icon: <Target size={20} />, permiso: 'menu_recruitment' },
  { id: 'rrhh', label: 'RRHH', path: '/admin/rrhh', icon: <FaUserTie size={20} />, permiso: 'menu_rrhh' },
  { id: 'reportes', label: 'Reportes', path: '/admin/reportes', icon: <LineChart size={20} />, permiso: 'menu_reports' },
  { id: 'reportesdeasistencia', label: 'Asistencia', path: '/admin/asistencia', icon: <Compass size={20} />, permiso: 'menu_asistencia' },
  { id: 'soporte', label: 'Soporte', path: '/admin/soporte', icon: <Headset size={20} />, permiso: 'menu_soporte' },
  { id: 'usuarios', label: 'Usuarios', path: '/admin/usuarios', icon: <Users size={20} />, permiso: 'menu_users' },
  { id: 'perfiles', label: 'Ajustes', path: '/admin/perfiles', icon: <Settings size={20} />, permiso: 'menu_settings' },
];


export const getMenuItemsByPermisos = (permisosUsuario) => {
  return allMenus.filter(menu => permisosUsuario?.includes(menu.permiso));
};


